export enum ConnectionsModalComponentsEnum {
	listOfConnections,
	addManuallyConnection,
	addQrCodeConnection,
	editConnection,
	optionsConnection,
	editOptionsConnection
}
